import { environment } from '../../environments/environment';

export function createCloudStorageUrl(path: string): string{
  // In order for this to work, the bucket must be publicly accessible.
  // See https://cloud.google.com/storage/docs/access-control/making-data-public
  return `https://storage.googleapis.com/${environment.firebase.storageBucket}${path}`;
}
